<template>
  <div class="healthy-card">
    <div class="card-box" v-for="(item, index) in healthyCardList" :key="index">
      <div class="content-box">
        <div>
          <div class="user-name">{{ item.name }}</div>
          <div class="user-num">健康卡：{{ item.idCard | idCardShield }}</div>
        </div>
        <div style="width:80px;display:flex;align-items: center;justify-content: space-between;">
          <a-icon
            type="right"
            style="font-size: 25px; color: #8a8989;"
            class="cursor-point"
            @click="goNext(item.idCard)"
          />
          <icon-font
            type="icon-pingjia"
            style="font-size: 25px; color: #5483F9;"
            class="cursor-point"
            @click="goNext(item.idCard)"
          />
        </div>
      </div>
    </div>
    <div
      v-if="healthyCardList.length < 5"
      class="card-box last-card"
      style="display: flex;
    align-items: center;"
    >
      <div class="content-box">
        <div class="user-num">
          <span class="cursor-point" @click="addNewCard" style="color:#5483F9">+添加健康卡</span>
          （还可以添加{{ 5 - healthyCardList.length }}张）
        </div>
      </div>
    </div>
    <div class="fast-binding" v-if="healthyCardList.length < 5">
      已有健康卡，
      <span class="cursor-point" style="color:#5483F9" @click="openFast">快速绑卡</span>
    </div>
    <Register-card ref="zcBind"></Register-card>
    <Fast-bind ref="fastBind"></Fast-bind>
  </div>
</template>
<script>
import RegisterCard from "@/components/RegisterCard";
import FastBind from "@/components/FastBind";
export default {
  components: {
    RegisterCard,
    FastBind,
  },
  data() {
    return {
      healthyCardList: [],
    };
  },
  created() {
    this.healthyCardList = JSON.parse(
      localStorage.getItem("sysUser")
    ).relationRecords;
  },
  methods: {
    addNewCard() {
      this.$refs.zcBind.onShow();
    },
    openFast() {
      this.$refs.fastBind.onShow();
    },
    goNext(val) {
      this.$router.push({
        path: "/user-center/healthy-card/change-healthy-card",
        query: {
          idCard: val,
        },
      });
    },
  },
  mounted() {},
  computed: {
    healthyCardListChange: function () {
      return this.$store.state.relationRecords;
    },
  },
  watch: {
    healthyCardListChange(n, m) {
      this.healthyCardList = n;
    },
  },
};
</script>
<style lang="less" scoped>
.healthy-card {
  width: 100%;
  padding: 65px 0;
  .card-box {
    width: 660px;
    height: 137px;
    margin: 23px auto;
    padding: 38px 110px;
    box-shadow: 0px 0px 12px 0px rgba(69, 157, 247, 0.3);

    .content-box {
      display: flex;
      justify-content: space-between;
      .user-name {
        font-size: 20px;
        font-weight: bold;
        color: #1c1c1c;
      }
      .user-num {
        font-size: 18px;
        font-weight: 400;
        color: #8a8989;
        // margin-top: 25px;
      }
    }
  }
  .last-card {
    height: 19px;
  }
  .fast-binding {
    text-align: center;
    margin-top: 30px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
  }
}
</style>
